import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Without this, navigating from the footer of one page to another leaves the
// viewport scrolled to the bottom, so the new page looks like "nothing happened".
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const target = document.querySelector(hash);
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      // Section not on this page yet (e.g. just navigated) — retry once after paint.
      const retry = setTimeout(() => {
        document.querySelector(hash)?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 250);
      return () => clearTimeout(retry);
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}
